export function formatDate(date) {
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) { dd = '0' + dd }
  if (mm < 10) { mm = '0' + mm }
  date = yyyy + '-' + mm + '-' + dd;
  return date
}

export function DaySets() {
  var result = [];
  for (var i = 0; i < 30; i++) {
    var d = new Date();
    d.setDate(d.getDate() - i);
    result.push(formatDate(d))
  }

  return result.reverse()
}

export function DaySetsNewDashboard(year, monthIndex) {
  const result = [];
  const date = new Date(year, monthIndex, 1);

  while (date.getMonth() === monthIndex) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    result.push({
      id: `${yyyy}-${mm}-${dd}`,
      label: `${parseInt(mm)}/${parseInt(dd)}`
    });
    date.setDate(date.getDate() + 1);
  }

  return result;
}



export function MonthlyDaySets(year, month) {
  var result = [];
  const startDateOfTheMonth = new Date(year, month);
  const endDateOfTheMonth = new Date(year, month + 1, 0).getDate();
  for (var i = 1; i <= endDateOfTheMonth; i++) {
    startDateOfTheMonth.setDate(i);
    result.push(formatDate(startDateOfTheMonth));
  }
  return result;
}